import axios from 'axios'
import { ElMessage } from 'element-plus'
import config from '@/config'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: config.baseApi, // 使用配置文件中的 baseApi
  timeout: config.timeout, // 使用配置文件中的超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem(config.tokenKey)
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果响应数据是字符串，尝试解析为JSON
    if (typeof res === 'string') {
      try {
        res = JSON.parse(res)
      } catch (e) {
        // 如果解析失败，直接返回原始数据
        return res
      }
    }

    // 检查响应状态
    if (res && res.code !== undefined) {
      // 如果返回的状态码不是200，说明接口请求有误
      if (res.code !== 200) {
        ElMessage({
          message: res.message || 'Error',
          type: 'error',
          duration: 5 * 1000
        })

        // 401: 未登录或token过期
        if (res.code === 401) {
          // 清除token
          localStorage.removeItem(config.tokenKey)
          // 跳转到登录页
        //   router.push('/login')
          return Promise.reject(new Error('登录已过期，请重新登录'))
        }
        return Promise.reject(new Error(res.message || 'Error'))
      }
      return res
    }
    
    // 如果没有code字段，直接返回数据
    return res
  },
  error => {
    console.error('Response error:', error)
    // 处理 HTTP 错误状态码
    if (error.response?.status === 401) {
      // 清除token
      localStorage.removeItem(config.tokenKey)
      // 跳转到登录页
    //   router.push('/login')
      return Promise.reject(new Error('登录已过期，请重新登录'))
    }
    
    const message = error.response?.data?.message || error.message || 'Request Error'
    ElMessage({
      message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service 